import TextAreaInput from '@components/FormComponents/TextAreaInput/textAreaInput';
import TextInput from '@components/FormComponents/TextInput';
import { PurchaseData, RecipientDetails } from '@lib/types';
import { Dispatch, SetStateAction } from 'react';
import style from "../PurchaseFlow.module.scss";


const RecipientDetailsComponent = ({
    recipientDetails,
    setPurchaseData,
}: {
    recipientDetails: RecipientDetails;
    setPurchaseData: Dispatch<SetStateAction<PurchaseData>>;
}) => {

    const handleRecipientDetailsChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>,
    ) => {
        const { name, value } = e.target;
        setPurchaseData((prev) => ({
            ...prev,
            recipientDetails: {
                ...prev.recipientDetails,
                [name]: value,
            },
        }));
    };

    return (
        <div>
            <form id="giftDetailsForm">
                <TextInput
                    onChange={handleRecipientDetailsChange}
                    id="recipientName"
                    name="recipientName"
                    title="Recipient Name"
                    type="text"
                    placeholder="Enter recipients full name"
                    required={true}
                    value={recipientDetails.recipientName || ''}
                />
                <TextInput
                    onChange={handleRecipientDetailsChange}
                    id="recipientEmail"
                    name="recipientEmail"
                    title="Recipient Email"
                    type="text"
                    placeholder="Enter recipients Email"
                    required={true}
                    value={recipientDetails.recipientEmail || ''}
                />
                <span className={style.tooltip}>Gift Card will be sent to this email address</span>
                <TextInput
                    onChange={handleRecipientDetailsChange}
                    id="senderName"
                    name="senderName"
                    title="Sender Name"
                    type="text"
                    placeholder="Sender Name"
                    required={true}
                    value={recipientDetails.senderName || ''}
                />
                <TextAreaInput
                    onChange={handleRecipientDetailsChange}
                    id="message"
                    name="message"
                    title="Message"
                    placeholder="Message"
                    required={true}
                    value={recipientDetails.message || ''}
                    maxLength={500}
                />
            </form>
        </div>
    );
};

export default RecipientDetailsComponent;
